<template>
    <div
        class="iframe-wrapper flex-grow-1 overflow-hidden d-flex flex-column ppv2-rounded-2xl ppv2-border ppv2-border-solid ppv2-border-black ppv2-border-opacity-20"
        :class="[{ loading: isLoadingIframe }, { backgroundColor: selectedWidget && backgroundColor }]"
        :style="{
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.15)',
        }"
    >
        <PreviewHeader />

        <div
            class="ppv2-mx-4 ppv2-mb-4 ppv2-flex-1 ppv2-flex ppv2-flex-col ppv2-rounded-xl ppv2-overflow-hidden ppv2-border ppv2-border-black ppv2-border-opacity-20"
            :style="{
                backgroundColor: selectedWidget && backgroundColor ? backgroundColor : '#070a13',
            }"
        >
            <BrowserChrome :selectedWidget="selectedWidget" :iframe-src="iframeSrc" :url-front="urlFront" />

            <div
                class="preview-body ppv2-flex-1 ppv2-flex ppv2-flex-col ppv2-items-stretch ppv2-relative"
                :class="{ 'ppv2-px-6': isProfileWidget }"
                style="max-height: 600px; overflow-y: auto"
            >
                <DefaultWidget v-if="!selectedWidget" />
                <div v-if="generatedCodeSnippet">
                    <WidgetExecutor :snippet="displaySnippet" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import WidgetExecutor from './preview/WidgetExecutor.vue'
import DefaultWidget from './preview/DefaultWidget.vue'
import PreviewHeader from './PreviewHeader.vue'
import BrowserChrome from './BrowserChrome.vue'
export default {
    name: 'IntegrationPreview',
    components: {
        WidgetExecutor,
        DefaultWidget,
        PreviewHeader,
        BrowserChrome,
    },
    props: {
        selectedWidget: {
            type: Object,
            default: null,
        },
        selectedItem: {
            type: Object,
            default: null,
        },
        iframeSrc: {
            type: String,
            default: null,
        },
        urlFront: {
            type: String,
            default: null,
        },
        activityIsValid: {
            type: Boolean,
            default: true,
        },
        isLoadingIframe: {
            type: Boolean,
            default: false,
        },
        cookieConsentExp: {
            type: Boolean,
            default: false,
        },
        activities: {
            type: Array,
            default: () => [],
        },
        categoryPrestations: {
            type: Array,
            default: () => [],
        },
        generatedCodeSnippet: {
            type: String,
            default: null,
        },
        backgroundColor: {
            type: String,
            default: null,
        },
    },
    computed: {
        isProfileWidget() {
            return this.selectedWidget?.id === 'profile'
        },
        displaySnippet() {
            if (!this.generatedCodeSnippet) return this.generatedCodeSnippet
            return `${this.generatedCodeSnippet}`
        },
    },
}
</script>

<style scoped>
.iframe-wrapper {
    min-height: 400px;
    transition: opacity 0.3s ease;
}

.iframe-wrapper.loading {
    opacity: 0.3;
}
</style>
